
const bad_word = ["操逼", "骚逼", "强奸", "屁眼", "骚", "sm", "SM", "鸡巴", "奶子", "主人", "母狗", "肉棒", "屁股",
    "插", "操", "草", "肏", "阴道", "高潮", "阴蒂", "文爱", "图爱", "肉便器", "自慰", "舔我", "乳头",
    "鸡吧", "操我", "穴", "裸聊", "调教", "sao", "B", "约炮", "约么", "污", "裸聊", "约啪", "插逼",
    "大肉棒", "做爱", "舔", "内射", "精液"
];

const ads_word = [
    "5", "6", "7", "8", "9", "五", "六", "七", "八", "九",
    "伍", "陆", "柒", "捌", "玖", "⑤", "⑥", "⑦", "⑧", "⑨",
    "微信", "扣扣", "q", "Q", "叔叔不约", "时时彩", "彩票", "v", "V"
];

// 检查手机号码的正则表达式
const phoneRegex = /(\+?\d{1,4}[\s-]?)?\d{10,11}/g;

// 检查微信、QQ号的正则表达式
const weChatOrQQRegex = /(wechat|wx|微信|qq|扣扣)[\s:：]?[\w-]+/gi;

String.prototype.ReplaceAll = function (oldstr, newstr) {//把f替换成e
    var reg = new RegExp(oldstr, "g"); //创建正则RegExp对象   
    return this.replace(reg, newstr);
}


/**************************************时间格式化处理************************************/
Date.prototype.Format = function (fmt) { //author: meizz   
    var o = {
        "M+": this.getMonth() + 1,                 //月份   
        "d+": this.getDate(),                    //日   
        "h+": this.getHours(),                   //小时   
        "m+": this.getMinutes(),                 //分   
        "s+": this.getSeconds(),                 //秒   
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
        "S": this.getMilliseconds()             //毫秒   
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export function dateDiff(dtm1, dtm2) {
    var rtn = '';

    var ss = dateDiff2(dtm1, dtm2);

    if (ss < 60) {
        rtn = ss.toString() + '秒';
        return rtn;
    }
    else if (ss < 60 * 60) {
        rtn = Math.floor(ss / 60).toString() + '分钟';
        return rtn;
    }
    else if (ss < 60 * 60 * 24) {
        rtn = Math.floor(ss / (60 * 60)).toString() + '小时';
        return rtn;
    }
    else if (ss < 60 * 60 * 24 * 30) {
        rtn = Math.floor(ss / (60 * 60 * 24)).toString() + '天';
        return rtn;
    }
    else {
        rtn = '很久以前';
        return rtn;
    }
}

export function dateDiff2(dtm1, dtm2) {
    var rtn = '';
    var sp = dtm2.getTime() - dtm1.getTime();
    var ss = Math.floor(sp / 1000);
    rtn = ss;
    return rtn;
}

export function dateDiff_Now(dtm1) {
    var rtn = '';
    var dtm2 = new Date();
    var sp = dtm2.getTime() - dtm1.getTime();
    var ss = Math.floor(sp / 1000);
    rtn = ss;
    return rtn;
}
/**************************************时间格式化处理************************************/

//生成从minNum到maxNum的随机数
export function randomNum(minNum, maxNum) {
    switch (arguments.length) {
        case 1:
            return parseInt(Math.random() * minNum + 1, 10);
            break;
        case 2:
            return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
            break;
        default:
            return 0;
            break;
    }
}


export function hasKey(arr, key, key_name) {
    var rtn = -1;
    var item;
    for (var i in arr) {
        item = arr[i];
        if (item[key_name] == key) {
            rtn = i;
            return rtn;
        }
    }
    return rtn;
}


export function slice_arry(arr, uinit_count) {
    var rtn = [];

    var arr_sub = [];
    for (var i = 0; i < arr.length; i++) {
        arr_sub.push(arr[i]);
        if ((i + 1) % uinit_count == 0) {
            rtn.push(arr_sub);
            arr_sub = [];
        }
    }
    if (arr_sub.length > 0) {
        rtn.push(arr_sub);
    }

    return rtn;
}

export function arry_sort(arr, sort_field, sort_type) {
    //sort_type 取值：num_asc, num_desc, dtm_asc, dtm_desc
    var temp = {};

    //已调整，其他算法错误
    if (sort_type == 'num_asc') {
        for (var i = 0; i < arr.length; i++) {
            for (var j = arr.length - 2; j >= 0; j--) {
                if (arr[j][sort_field] > arr[j + 1][sort_field]) {
                    //交换
                    temp = arr[j];
                    arr[j] = arr[j + 1];
                    arr[j + 1] = temp;
                }
            }
        }
    }

    if (sort_type == 'num_desc') {
        for (var i = 0; i < arr.length; i++) {
            for (var j = i; j < arr.length - 1; j++) {
                if (arr[j][sort_field] < arr[j + 1][sort_field]) {
                    //交换
                    temp = arr[j];
                    arr[j] = arr[j + 1];
                    arr[j + 1] = temp;
                }
            }
        }
    }

    if (sort_type == 'dtm_asc') {
        for (var i = 0; i < arr.length; i++) {
            for (var j = i; j < arr.length - 1; j++) {
                var sp_1 = dateDiff_Now(new Date(arr[j][sort_field]));
                var sp_2 = dateDiff_Now(new Date(arr[j + 1][sort_field]));
                if (sp_1 < sp_2) {
                    //交换
                    temp = arr[j];
                    arr[j] = arr[j + 1];
                    arr[j + 1] = temp;
                }
            }
        }
    }

    //已调整，其他算法错误
    if (sort_type == 'dtm_desc') {
        for (var i = 0; i < arr.length; i++) {
            for (var j = arr.length - 2; j >= 0; j--) {
                var sp_1 = dateDiff_Now(new Date(arr[j][sort_field]));
                var sp_2 = dateDiff_Now(new Date(arr[j + 1][sort_field]));
                if (sp_1 > sp_2) {
                    //交换
                    temp = arr[j];
                    arr[j] = arr[j + 1];
                    arr[j + 1] = temp;
                }
            }
        }
    }

    return arr;
}

export function trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "")
}


/*
*  功能:   验证是否是手机号 
*  参数:   tel:手机号码
*  返回值：
*  作者：钟旺
*  日期：2017-01-17
*  版本：1.0
*/
export function IsTelephone(tel) {
    if (tel == "") {
        return false;
    }
    if (!(/^1[3456789]\d{9}$/.test(tel))) {
        return false;
    }
    return true;
}

/*
*  功能:   图片压缩处理
*  参数:   
*  返回值：
*  作者：
*  日期：
*  版本：1.0
*/

export function compress(img, Orientation) {
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d');
    //瓦片canvas  
    let tCanvas = document.createElement("canvas");
    let tctx = tCanvas.getContext("2d");
    let initSize = img.src.length;
    let width = img.width;
    let height = img.height;
    //console.log("图片原始宽度*高度--->" + width + "*" + height);
    //如果图片大于四百万像素，计算压缩比并将大小压至400万以下  
    let ratio;
    if ((ratio = width * height / 4000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
    } else {
        ratio = 1;
    }
    //console.log("ratio:" + ratio);
    canvas.width = width;
    canvas.height = height;
    //console.log("图片处理后的宽度*高度--->" + width + "*" + height);
    //        铺底色  
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    //如果图片像素大于100万则使用瓦片绘制  
    let count;
    if ((count = width * height / 1000000) > 1) {
        //console.log("大于100万像素使用瓦片绘制..." + count);
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片  
        //            计算每块瓦片的宽和高  
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
        }
    } else {
        //console.log("小于100万像素，直接绘制..." + count);
        ctx.drawImage(img, 0, 0, width, height);
    }
    //修复ios上传图片的时候 被旋转的问题  
    if (Orientation != "" && Orientation != 1) {

        switch (Orientation) {
            case 6://需要顺时针（向左）90度旋转  
                this.rotateImg(img, 'left', canvas);
                break;
            case 8://需要逆时针（向右）90度旋转  
                this.rotateImg(img, 'right', canvas);
                break;
            case 3://需要180度旋转  
                this.rotateImg(img, 'right', canvas);//转两次  
                this.rotateImg(img, 'right', canvas);
                break;
        }
    }
    //进行压缩  
    let ndata = canvas.toDataURL('image/jpeg', 0.6);
    // console.log('压缩前：' + initSize);
    // console.log('压缩后：' + ndata.length);
    // console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
    tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
    return ndata;
}

export function compress_mult(img, Orientation, mult) {
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d');
    //瓦片canvas  
    let tCanvas = document.createElement("canvas");
    let tctx = tCanvas.getContext("2d");
    let initSize = img.src.length;
    let width = img.width;
    let height = img.height;
    //console.log("图片原始宽度*高度--->" + width + "*" + height);
    //如果图片大于四百万像素，计算压缩比并将大小压至400万以下  
    let ratio;
    if ((ratio = width * height / 4000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
    } else {
        ratio = 1;
    }
    //console.log("ratio:" + ratio);
    canvas.width = width;
    canvas.height = height;
    //console.log("图片处理后的宽度*高度--->" + width + "*" + height);
    //        铺底色  
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    //如果图片像素大于100万则使用瓦片绘制  
    let count;
    if ((count = width * height / 1000000) > 1) {
        //console.log("大于100万像素使用瓦片绘制..." + count);
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片  
        //            计算每块瓦片的宽和高  
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
            for (let j = 0; j < count; j++) {
                tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
        }
    } else {
        //console.log("小于100万像素，直接绘制..." + count);
        ctx.drawImage(img, 0, 0, width, height);
    }
    //修复ios上传图片的时候 被旋转的问题  
    if (Orientation != "" && Orientation != 1) {

        switch (Orientation) {
            case 6://需要顺时针（向左）90度旋转  
                this.rotateImg(img, 'left', canvas);
                break;
            case 8://需要逆时针（向右）90度旋转  
                this.rotateImg(img, 'right', canvas);
                break;
            case 3://需要180度旋转  
                this.rotateImg(img, 'right', canvas);//转两次  
                this.rotateImg(img, 'right', canvas);
                break;
        }
    }
    //进行压缩  
    let ndata = canvas.toDataURL('image/jpeg', mult);
    console.log('压缩前：' + initSize);
    console.log('压缩后：' + ndata.length);
    console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
    tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
    return ndata;
}

/*
*  功能:   图片压缩处理
*  参数:   
*  返回值：
*  作者：
*  日期：
*  版本：1.0
*/
export function rotateImg(img, direction, canvas) {
    //最小与最大旋转方向，图片旋转4次后回到原方向      
    const min_step = 0;
    const max_step = 3;
    if (img == null) return;
    //img的高度和宽度不能在img元素隐藏后获取，否则会出错      
    let height = img.height;
    let width = img.width;
    let step = 2;
    if (step == null) {
        step = min_step;
    }
    if (direction == 'right') {
        step++;
        //旋转到原位置，即超过最大值      
        step > max_step && (step = min_step);
    } else {
        step--;
        step < min_step && (step = max_step);
    }
    //旋转角度以弧度值为参数      
    let degree = step * 90 * Math.PI / 180;
    let ctx = canvas.getContext('2d');
    switch (step) {
        case 0:
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            break;
        case 1:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, 0, -height);
            break;
        case 2:
            canvas.width = width;
            canvas.height = height;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, -height);
            break;
        case 3:
            canvas.width = height;
            canvas.height = width;
            ctx.rotate(degree);
            ctx.drawImage(img, -width, 0);
            break;
    }
}

/*
*  功能:   播放声音
*  参数:   
*  返回值：
*  作者：
*  日期：
*  版本：1.0
*/
export function playSound_match() {
    playSound("sound_match");
}
export function playSound_send() {
    playSound("sound_send");
}
export function playSound_receive() {
    playSound("sound_receive");
}
export function playSound_keydown() {
    playSound("sound_keydown");
}

export function playSound(id_name) {
    var audio = document.getElementById(id_name);
    audio.currentTime = 0;
    audio.play();
}



export function getGiftItemBy_name(ary_gift, gift_name) {
    var gift_item = '';

    for (var i = 0; i < ary_gift.length; i++) {
        if (ary_gift[i].name == gift_name) {
            gift_item = ary_gift[i];
        }
    }

    if (!gift_item) {
        gift_item = ary_gift[0];
    }

    return gift_item;
}


//接收检查(消息相关)
export function receive_check(context, msg) {
    var bRtn = true;
    //检查消息结构的合法性
    if (!msg || !msg.from || !msg.type || !msg.txt || !msg.dtm) {
        bRtn = false;
        return bRtn;
    }

    //拉黑检查（我是否拉黑了对方）
    var my_complain = context.state.my_complain;
    if (hasKey(my_complain, msg.from, 'uid') >= 0) {
        bRtn = false;
        return bRtn;
    }
    //封号检查（对方是否被封号）
    //......

    //检查是否是探测消息
    if (msg.type == "sys_probe") {
        // //探测状态消息
        var type = msg.txt.txt;
        if (type == "探测消息") {
            bRtn = false;
        }
        //更新用户信息业务
        if (type == "更新信息") {
            context.commit('set_objVal', {"is_update_user_info" : true});
        }
        //更新用户封号状态
        if (type == "更新封号状态") {
            var id = msg.txt.id;
            context.commit('set_objVal', {"update_kill" : id});
        }
        
        bRtn = false;
        return bRtn;
    }

    if (msg.type == "voice_res") {
        //接收语音回执
        var serverId = msg.txt;
        var to_uid = msg.from;
        var message = context.state.message;
        
        var idx = hasKey(message, to_uid, "to");
        if (idx >= 0) {
            var txts = message[idx]["txts"];
           var item =  txts.filter(item=> item.msg.msg_txt.serverId == serverId)
            if (item.length > 0) {
                item[0].to_res_tag = true;
            }
        }
        bRtn = false;
        return bRtn;
    }

    //检查是否是礼物消息
    if (msg.type == "gift") {
        context.commit('set_objVal', {"is_first_gift" : true});
    }

    return bRtn;
}

//接收系统类型
export function receive_sys(context, msg) {
    var rtn;
    //警告
    if (msg.type == 'sys_warn') {
        rtn = msg.txt / 1000;
        context.commit('set_warn_info', rtn);
    }

    //封号
    if (msg.type == 'sys_kill') {
        // 计算解封时间
        var dtmDate = new Date(msg.dtm).getTime();
        var unbanTime = new Date(dtmDate + msg.txt.kill_time);
        var end_time = unbanTime.toLocaleString();

        var killTimeHours = msg.txt.kill_time / (1000 * 60 * 60);

        var rtn = {
          "reason": msg.txt.kill_ause,
          "hour": killTimeHours,
          "dtm_kill": msg.dtm,
          "dtm_unkill": end_time,
          "kill_id": msg.from,
          "state": "1",
          "msg": "封杀中"
        }
        context.commit('set_kill_info', rtn);
      }
}

export function receive_After(context, msg) {
    //收到礼物，增加积分处理
    context.dispatch('act_receive_gift', msg);
    //收到对方的拉黑处理
    context.dispatch('act_receive_sys', msg);

    //当有新消息时候，立即获取用户信息
    var userinfo = context.state.userinfo;
    var idx = hasKey(userinfo, msg.from, 'uid');
    if (idx < 0) {
        context.dispatch('act_get_userinfo', {
            uid: msg.from,
            success: function (info) {
                //console.log('新的聊天者来了，第一条消息....');
            }
        });
    }
}

//1. 消息格式完整化（礼物消息、好友消息、拉黑消息）
export function complate_msg(state, const_data, msg_dtl, tag) {
    //礼物消息完整化
    if (msg_dtl.msg_type == 'gift') {
        var gift_item = {};
        var url = msg_dtl.msg_txt;
        var arr = const_data.gift_1.concat(const_data.gift_2);
        var idx = hasKey(arr, url, 'url');
        if (idx >= 0) {
            gift_item = arr[idx];
            msg_dtl.msg_attach = gift_item;
        }
        else {
            gift_item = arr[0];
            msg_dtl.msg_attach = gift_item;
        }
    }
    
    //接收到语音消息的特殊处理
    if (msg_dtl.msg_type == 'voice' && tag == 'to') {
        msg_dtl.msg_txt.localId = '';
        
    }

    //拉黑消息
    if (msg_dtl.msg_type == '拉黑') {
        if (tag == 'self') {
            msg_dtl.msg_txt = '你已将对方拉黑';
        }
        else {
            msg_dtl.msg_txt = '对方已将你拉黑';
        }
    }

    //加好友消息
    if (msg_dtl.msg_type == 'sys_friend') {
        if (tag == 'self') {
            switch (msg_dtl.msg_txt) {
                case "发送申请":
                    msg_dtl.msg_attach = '我申请添加对方为好友';
                    break;
                case "发送-通过":
                    msg_dtl.msg_attach = '我通过了你的好友申请';
                    break;
                case "发送-拒绝":
                    msg_dtl.msg_attach = '我拒绝了你的好友申请';
                    break;
            }
        }
        else {
            switch (msg_dtl.msg_txt) {
                case "发送申请":
                    msg_dtl.msg_attach = '对方请求添加为好友';
                    break;
                case "发送-通过":
                    msg_dtl.msg_attach = '我通过了你的好友申请';
                    break;
                case "发送-拒绝":
                    msg_dtl.msg_attach = '我拒绝了你的好友申请';
                    break;
            }
        }
    }

    //封号消息
    if (msg_dtl.msg_type == 'sys_kill') {
        msg_dtl.msg_txt.kill_time = msg_dtl.msg_txt.kill_time / (1000 * 60 * 60);
    }

    //警告消息
    if (msg_dtl.msg_type == 'sys_warn') {
        msg_dtl.msg_txt = msg_dtl.msg_txt / 1000;
    }

    return msg_dtl;
}
//2. 处理文本消息（恶俗词汇、广告词汇过滤）（目前只处理接收消息）
export function deal_msg_txt(msg_dtl) {
    var msg_type = msg_dtl.msg_type;
    var msg_txt = msg_dtl.msg_txt;
    var msg_txt_old = msg_txt;

    //敏感词汇过滤
    if (msg_type == 'text') {
        var word_item;
        //恶俗词汇过滤
        for (var i in bad_word) {
            word_item = bad_word[i];
            msg_txt = msg_txt.ReplaceAll(word_item, '*');
        }
        //广告过滤
        // for (var ii in ads_word) {
        //     word_item = ads_word[ii];
        //     msg_txt = msg_txt.ReplaceAll(word_item, '.');
        // }

        // // 手机号码过滤
        // msg_txt = msg_txt.replace(phoneRegex, '*******');

        // // 微信号和QQ号过滤
        // msg_txt = msg_txt.replace(weChatOrQQRegex, '******');
    }

    var rtn = {
        'msg_type': msg_type,
        'msg_txt': msg_txt,
        'msg_txt_old': msg_txt_old
    };

    return rtn;
}
//3. 消息格式完整化（礼物消息、好友消息、拉黑消息）
export function formate_msg(to, msg_dtl, tag, dtm) {
    var sp = '1s';

    var diff = dateDiff2(new Date(dtm), new Date());
    if (diff <= 0) {
        sp = '1s';
    } else {
        sp = dateDiff(new Date(dtm), new Date());
    }

    var msg_item = {
        dtm: dtm,
        dtm_sp: sp,
        msg: msg_dtl,
        tag: tag
    };

    if (tag == 'to') {
        //对方的消息
        msg_item.read_tag = false;
    }

    return msg_item;
}

//消息排序
export function msg_sort(message) {
    var arr_temp = [];
    for (var i in message) {
        var uid = message[i]['to'];
        var least_dtm = message[i].txts[message[i].txts.length - 1].dtm;
        var dtm_sp_count = dateDiff2(new Date(least_dtm), new Date());

        var f_item = {
            'uid': uid,
            'dtm_sp_count': dtm_sp_count
        }
        arr_temp.push(f_item);
    }
    arr_temp = arry_sort(arr_temp, 'dtm_sp_count', 'num_asc');
    return arr_temp;
}

//单次对话统计
export function sum_chart(message, to) {
    var arr = [];
    var idx = hasKey(message, to, 'to')
    if (idx >= 0) {
        arr = message[idx]['txts'];
    }

    var count_self = 0;
    var count_to = 0;
    var count_total = 0;

    if (arr.length > 0) {
        for (var i in arr) {
            if (arr[i].tag == 'to') {
                count_to++;
            }
            if (arr[i].tag == 'self') {
                count_self++;
            }
        }
        count_total = count_to + count_self;
    }

    var rtn = {
        'count_self': count_self,
        'count_to': count_to,
        'count_total': count_total
    };

    return rtn;
}


//计算红点数(未读消息计算)
export function calculate_noread_count(message, uid) {
    var icount = 0;
    var idx = hasKey(message, uid, "to");
    if (idx >= 0) {
        //优化执行效率(倒序计算)
        var arr = message[idx]["txts"];
        for (var i in arr) {
            if (arr[i].read_tag == false) {
                icount++;
            }
        }
    }
    return icount;
}
//计算未读消息等级（等级越高，越紧急）
export function calculate_noread_level(message, uid) {
    var icount = 0;
    var idx = hasKey(message, uid, "to");
    if (idx >= 0) {
        //优化执行效率(倒序计算)
        var arr = message[idx]["txts"];
        for (var i in arr) {
            if (arr[i].read_tag == false) {
                icount++;
            }
        }
    }

    var rtn_level = 0;

    if (icount > 0) {
        var data_sum = sum_chart(message, uid);
        var count_self = data_sum.count_self;
        if (count_self < 5) {
            rtn_level = 5 - count_self;
        }
    }

    return rtn_level;

}
//计算红点数(未读消息计算)
export function calculate_noreadAll_count(message) {
    var icount = 0;
    var len = message.length;
    var len_sub = 0;
    var item;
    for (var i = 0; i < len; i++) {
        item = message[i]['txts'];
        len_sub = item.length;
        for (var ii = len_sub - 1; ii >= 0; ii--) {
            if (item[ii].read_tag == false) {
                icount++;
            }
            else {
                break;
            }
        }
    }
    return icount;
}

//检测是否为朋友关系
export function check_friend(my_friend, uid) {
    for (var i in my_friend) {
        var item_uid = my_friend[i].uid;
        if (item_uid == uid) {
            return true;
        }
    }
    return false;
}

//加载并解析本地缓存数据
export function load_locData(state) {
    var loc_message = localStorage.getItem('loc_message');
    var loc_userinfo = localStorage.getItem('loc_userinfo');
    if (loc_message) {
        var msg_history = JSON.parse(loc_message);
        //整理缓存消息（去掉长时间没有消息的用户:大于2小时，则移除）
        if (msg_history.length >= 20) {
            var msg = msg_sort(msg_history);
            //console.log(JSON.stringify(msg_sort));
            for (var i in msg) {
                var diff_ss = msg[i].dtm_sp_count;
                if ((diff_ss / (60 * 60)) >= 24) {
                    var idx = hasKey(msg_history, msg[i].uid, 'to');
                    if (idx >= 0) {
                        msg_history.splice(idx, 1);
                    }
                }
            }
        }

        state.message = msg_history;
        //本地缓存
        localStorage.setItem('loc_message', JSON.stringify(state.message));
    }
    if (loc_userinfo) {
        //清理用户信息(去除过多的用户信息，和消息列表保持同步)
        var user_history = JSON.parse(loc_userinfo);
        var ary_user = [];
        var uid = '';
        for (var i = 0; i < state.message.length; i++) {
            uid = state.message[i].to;
            var idx = hasKey(user_history, uid, 'uid');
            if (idx >= 0) {
                ary_user.push(user_history[idx]);
            }
        }

        uid = state.uid;
        var idx = hasKey(user_history, uid, 'uid');
        if (idx >= 0) {
            ary_user.push(user_history[idx]);
        }

        state.userinfo = ary_user;
    }
}

 // 各主流浏览器
 export function getBrowser() {
    var u = navigator.userAgent;
 
    var bws = [{
        name: 'sgssapp',
        it: /sogousearch/i.test(u)
    }, {
        name: 'wechat',
        it: /MicroMessenger/i.test(u)
    }, {
        name: 'weibo',
        it: !!u.match(/Weibo/i)
    }, {
        name: 'uc',
        it: !!u.match(/UCBrowser/i) || u.indexOf(' UBrowser') > -1
    }, {
        name: 'sogou',
        it: u.indexOf('MetaSr') > -1 || u.indexOf('Sogou') > -1
    }, {
        name: 'xiaomi',
        it: u.indexOf('MiuiBrowser') > -1
    }, {
        name: 'baidu',
        it: u.indexOf('Baidu') > -1 || u.indexOf('BIDUBrowser') > -1
    }, {
        name: '360',
        it: u.indexOf('360EE') > -1 || u.indexOf('360SE') > -1
    }, {
        name: '2345',
        it: u.indexOf('2345Explorer') > -1
    }, {
        name: 'edge',
        it: u.indexOf('Edge') > -1
    }, {
        name: 'ie11',
        it: u.indexOf('Trident') > -1 && u.indexOf('rv:11.0') > -1
    }, {
        name: 'ie',
        it: u.indexOf('compatible') > -1 && u.indexOf('MSIE') > -1
    }, {
        name: 'firefox',
        it: u.indexOf('Firefox') > -1
    }, {
        name: 'safari',
        it: u.indexOf('Safari') > -1 && u.indexOf('Chrome') === -1
    }, {
        name: 'qqbrowser',
        it: u.indexOf('MQQBrowser') > -1 && u.indexOf(' QQ') === -1
    }, {
        name: 'qq',
        it: u.indexOf('QQ') > -1
    }, {
        name: 'chrome',
        it: u.indexOf('Chrome') > -1 || u.indexOf('CriOS') > -1
    }, {
        name: 'opera',
        it: u.indexOf('Opera') > -1 || u.indexOf('OPR') > -1
    }];
 
    for (var i = 0; i < bws.length; i++) {
        if (bws[i].it) {
            return bws[i].name;
        }
    }
 
    return 'other';
}
 
// 系统区分
export function getOS() {
    var u = navigator.userAgent;
    if (!!u.match(/compatible/i) || u.match(/Windows/i)) {
        return 'windows';
    } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
        return 'macOS';
    } else if (!!u.match(/iphone/i) || u.match(/Ipad/i)) {
        return 'ios';
    } else if (!!u.match(/android/i)) {
        return 'android';
    } else {
        return 'other';
    }
}

//获取浏览设备信息
export function  get_client_info() {
    var is_mobile_browser = false;
    var is_ios= false;
    var is_andriod = false;
    var is_wx= false;
    var is_pc= false;
    var browser= "";//浏览器
    var os= ""; //操作系统
    var info= "";
    
    const u = navigator.userAgent;

    // 当前设备是移动设备
    is_mobile_browser = /Mobi|Android|iPhone/i.test(u);
    is_pc = !is_mobile_browser;

    is_ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    is_andriod = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    is_wx = u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger';
    
    browser = getBrowser();
    os = getOS();
    //保存设备的信息
    info = u;

    var obj = {
      is_mobile_browser: is_mobile_browser,
      is_ios: is_ios,
      is_andriod: is_andriod,
      is_wx: is_wx,
      is_pc: is_pc,
      browser: browser, //浏览器
      os: os, //操作系统
      info: info
    }

    return obj;
}

export function send_check_msg(self, type, msg, is_send_wxMsg) {
        var sysdic = self.$store.state.sysdic;
        var xhc_admin_uid = sysdic.xhc_admin_uid;
       
        var send_msg = { to: xhc_admin_uid, type: type, txt: msg };
        send_msg.dtm = new Date().Format("yyyy/MM/dd hh:mm:ss");
        self.$socket.emit("send_one", send_msg);
        // //整理消息，本地store中保存
        var data = {
            "from": xhc_admin_uid,
            "type": type,
            "txt": msg,
            "dtm": send_msg.dtm
        };
        
        if (type !== "check_seek_people" && type !== "check_feedback") {
            self.$store.dispatch('act_push_message', data);
        }

        //发送微信通知
        //获取微信模板消息相关参数
        if (is_send_wxMsg) {
        var data = {
            "url": "http://admin_i.xiaohuochai888.com/",
            "first": "-",
            "keyword1": "审核通知",
            "keyword2": "-",
            "keyword3": new Date().Format("yyyy/MM/dd hh:mm:ss"),
            "keyword4": msg.txt
        };
        
        var wx_notice_uid = sysdic.wx_notice_check;
        var tag = "999";
        var strData =  JSON.stringify(data)
          self.post({
            url: "/Common/WxSendMsg2",
            data: { uid: wx_notice_uid, tag:tag, data: strData },
            success: function (serve_data) {
              console.log(JSON.stringify(serve_data));
            },
          });
        }
        
}

//夜间模式
export function is_theme_dark(self) {
    var rtn = false;
    var objVal = self.$store.state.objVal;
    rtn = objVal.theme_dark;
    return rtn;
}

/* -------------聊天挣钱相关----start------------------- */

//聊天深度
export function is_hello_boy(txts) {
    var rtn = true;
    var deep = 0;
    if (txts.length <= 0) {
        return rtn;
    }
    var tag = true;
        var item;
        var last_msg = "";

        for (var i = 0; i < txts.length; i++) {
            item = txts[i];
            if (item.tag == 'self' && tag == true) {
                deep++;
                tag = false;
                last_msg = item;
            }
            if (item.tag == 'to') {
                tag = true;
                last_msg = item;
            } 
            if (deep > 1) {
                break;
            }
        }
        rtn = false;
        if (deep == 0) {
            rtn = true;
        }
        if (deep == 1 && last_msg.tag == "self") {
            rtn = true;
        }
    return rtn;
}

export function is_hello_girl(txts) {
    var rtn = true;
    var deep = 0;
    if (txts.length <= 0) {
        return rtn;
    }
    var tag = true;
    var item;
    for (var i = 0; i < txts.length; i++) {
        item = txts[i];
        if (item.tag == 'to' && tag == true) {
            deep++;
            tag = false;
        }
        if (item.tag == 'self') {
            tag = true;
        } 
        if (deep > 1) {
            break;
        }
    }
    rtn = false;
    if (deep < 2) {
        rtn = true;
    }
    return rtn;
}

export function get_to_msg(txts) {
  var to_msgs = [];
    if (txts.length > 0) {
        var item;
        for (var i = txts.length - 1; i > 0; i--) {
            item = txts[i];
            if (item.tag == 'self') {
                return to_msgs;
            }

            if (item.tag == 'to') {
                to_msgs.push(item);
            }
        }
    }
  
  return to_msgs;
}

//计算对方最小消息时间
export function get_to_Mindtm(msgs) {
    var min_dtm = new Date().getTime();
    var item_dtm;
    for (var i = 0; i < msgs.length; i++) {
        item_dtm = msgs[i].dtm;
        item_dtm = item_dtm.replace(/-/g, "/");
        item_dtm = new Date(item_dtm).getTime();
        
        if (item_dtm < min_dtm) {
            min_dtm = item_dtm;
        }
    }
    return min_dtm;
}

//用户在线动作统计
export function set_user_action(action, p) {
    var data = JSON.parse(localStorage.getItem("loc_online_action")) || [];

    if (data.length > 0) {
        var last = data[data.length - 1];
        var dtm_last = new Date(last.dtm).getTime();
        var dtm_now = new Date().getTime();
        var diff_second = (dtm_now - dtm_last) / 1000;
        //一分钟内动作过滤
        if (diff_second < 60) {
            return false;
        }
    }

    var item = {
        dtm: new Date().Format("yyyy/MM/dd hh:mm:ss"),
        action: action
    };

    if (p) {
        item.parames = p;
    }

    data.push(item);
    localStorage.setItem("loc_online_action", JSON.stringify(data));
}


export function get_online_time() {
    var time_second = 0;
    var currentTime = 0;
    var diff_second = 0;
    var data = JSON.parse(localStorage.getItem("loc_online_action"));
    if (data.length < 2) {
         return false;
    }
      
    var lastTime = new Date(data[0].dtm).getTime();
    for (var i = 1; i < data.length; i++) {
      currentTime = new Date(data[i].dtm).getTime();
      diff_second = (currentTime - lastTime) / (1000);
      //超过三分钟过滤
      if (diff_second <= 60 * 3) {
        time_second += diff_second;
      }
      lastTime = currentTime;
    }
    return time_second;
}

//清理昨日在线动作
export function clear_online_action() {
    var dtm_base = new Date().toLocaleDateString();
    var data = JSON.parse(localStorage.getItem("loc_online_action"));
    if (!data) {
        return false;
    }
    var today_action = data.filter(item => new Date(item.dtm).getTime() > new Date(dtm_base).getTime());
    localStorage.setItem("loc_online_action", JSON.stringify(today_action));
}

//存储用户打招呼统计
export function set_user_hello(txts, uinfo_from, uinfo_to, tag) {
    //第一步检查是否存储打招呼
    //是异性
    if (uinfo_from.sex === uinfo_to.sex) {
        return false;
    }
    //超过任务值之后不存储
    var data = JSON.parse(localStorage.getItem("loc_chat_hello")) || [];
      if (data.length >= 10) {
        return false;
    }
    //已存储的用户过滤
    var exist = data.some(item => item.to === uinfo_to.uid);
    if (exist) {
        return false;
    }

    //第二步根据条件是否存储
    if (tag == true) {
        var self_msgs = txts.filter(item=> item.tag == "self");
        var to_msgs = txts.filter(item=> item.tag == "to");
        if (to_msgs.length <= 0 && self_msgs.length <= 1) {
            var item = {
                dtm: new Date().Format("yyyy/MM/dd hh:mm:ss"),
                to: uinfo_to.uid
            };
        
            data.push(item);
            localStorage.setItem("loc_chat_hello", JSON.stringify(data));
        }
    } else {
        var item = {
            dtm: new Date().Format("yyyy/MM/dd hh:mm:ss"),
            to: uinfo_to.uid
        };
    
        data.push(item);
        localStorage.setItem("loc_chat_hello", JSON.stringify(data));
    }

     //每次保存都清理不是当天的招呼
     clear_chat_coin_hello();

}
//存储用户回复统计
export function set_user_answer(txts,uinfo_from, uinfo_to) {
    //第一步检查是否存储回复
    //是异性
    if (uinfo_from.sex === uinfo_to.sex) {
        return false;
    }
    var data = JSON.parse(localStorage.getItem("loc_chat_answer")) || [];
    if (data.length >= 10) {
      return false;
    }
    //已存储的用户过滤
    var exist = data.some(item => item.to === uinfo_to.uid);
     if (exist) {
        return false;
    }
    //过滤打招呼用户
    var loc_chat_hello = JSON.parse(localStorage.getItem("loc_chat_hello")) || [];
    var hello_exist = loc_chat_hello.some(item => item.to === uinfo_to.uid);
    if (hello_exist) {
        return false;
    }


    //第二步根据条件是否存储
    var to_msgs = txts.filter(item=> item.tag == "to");
      if (to_msgs.length >= 1) {
    
        var item = {
            dtm: new Date().Format("yyyy/MM/dd hh:mm:ss"),
            to: uinfo_to.uid
        };
    
        data.push(item);
        localStorage.setItem("loc_chat_answer", JSON.stringify(data));
      }

      //每次保存都清理不是当天的回复
      clear_chat_coin_answer();
}

//清理昨天的打招呼
export function clear_chat_coin_hello() {
    var dtm_base = new Date().toLocaleDateString();
    var data = JSON.parse(localStorage.getItem("loc_chat_hello"));
    if (!data) {
        return false;
    }
    var today_hello = data.filter(item => new Date(item.dtm).getTime() > new Date(dtm_base).getTime());
    localStorage.setItem("loc_chat_hello", JSON.stringify(today_hello));
}

//清理昨天的回复
export function clear_chat_coin_answer() {
    var dtm_base = new Date().toLocaleDateString();
    var data = JSON.parse(localStorage.getItem("loc_chat_answer"));
    if (!data) {
        return false;
    }
    var today_hello = data.filter(item => new Date(item.dtm).getTime() > new Date(dtm_base).getTime());
    localStorage.setItem("loc_chat_answer", JSON.stringify(today_hello));
}
  /* -------------聊天挣钱相关----end------------------- */

  
  //滚动增加数量效果
  export function roll_add_num(target, elementId, unit) {
    var start = 0;
    var steps = 100; // 定义更新次数
    var increment = Math.ceil(target / steps); // 每次增加的值
    var current = start;

    var stepTime = 1000 / steps; // 每步的时间

    var interval = setInterval(() => {
        current += increment;
        if (document.getElementById(elementId) == null || document.getElementById(elementId) == undefined) {
            return false;
        }
        document.getElementById(elementId).textContent = current + unit;

        if (current >= target) {
            clearInterval(interval);
            document.getElementById(elementId).textContent = target + unit; // 确保显示最大值
        }
    }, stepTime);
}

export function set_delete_friends(uid) {
    var data = JSON.parse(localStorage.getItem("loc_delete_friends")) || [];
      var item = {
        dtm: new Date().Format("yyyy/MM/dd hh:mm:ss"),
        uid: uid
      } 
      data.push(item);
      localStorage.setItem("loc_delete_friends", JSON.stringify(data));
}

export function clear_delete_friends() {
    var currentTime = new Date().getTime();
    var data = JSON.parse(localStorage.getItem("loc_delete_friends"));
    if (!data) {
        return false;
    }

    //清理超过一小时的
    var recently_delete = data.filter(item => {
        var itemTime = new Date(item.dtm).getTime();
        return currentTime - itemTime <= 60 * 60 * 1000;
    });

    localStorage.setItem("loc_delete_friends", JSON.stringify(recently_delete));
}


export function is_delete_friends(to_uid) {
    var rtn = false;
    clear_delete_friends();
    var data = JSON.parse(localStorage.getItem("loc_delete_friends")) || [];
    var recently_delete = data.some(item => item.uid === to_uid);
    if (recently_delete) {
        rtn = true;
    }
    return rtn;
}

